import { useMutation } from '@tanstack/react-query';
import type {
  SendPrescriptionsRequestT,
  SendPrescriptionsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSendPrescriptionsToPharmacy } from '../api/sendPrescriptionsToPharmacy.js';

export interface SendPrescriptionsToPharmacyVariables {
  userId: string;
  data: SendPrescriptionsRequestT;
}

export function useSendPrescriptionsToPharmacyMutation() {
  return useMutation<SendPrescriptionsResponseT, Error, SendPrescriptionsToPharmacyVariables>({
    mutationKey: ['rx', 'send-prescriptions-to-pharmacy'],
    mutationFn: ({ userId, data }) => fetchSendPrescriptionsToPharmacy(userId, data),
  });
}
